"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalLink = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_context_1 = require("../_util/config-context");
exports.ExternalLink = react_1.forwardRef(function (_a, ref) {
    var _b;
    var className = _a.className, weak = _a.weak, children = _a.children, props = tslib_1.__rest(_a, ["className", "weak", "children"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    return (react_1.default.createElement("a", tslib_1.__assign({ target: "_blank" }, props, { ref: ref, className: classnames_1.default(classPrefix + "-link-external", (_b = {},
            _b[classPrefix + "-link-external--black"] = weak,
            _b), className) }), children));
});
exports.ExternalLink.displayName = "ExternalLink";
//# sourceMappingURL=ExternalLink.js.map